import { Separator } from "@radix-ui/react-select";
import { Card } from "../../components/Shared/Card";
import { Content } from "../../components/ui/ContentArea";
import { FactoresTable } from "../../components/User/CustomFactores/FactoresTable";

export function CustomFactoresPage() {
	return (
		<Content className="p-5">
			<title>Editar Factores Personalizados</title>
			<Card>
				<h1 className="text-xl font-bold">Editar Factores Personalizados</h1>
				<Separator />
				<FactoresTable />
			</Card>
		</Content>
	);
}
